/**
 * A Pinia setup store runs inside whichever component first calls it, and
 * vue-apollo stops a query when that component unmounts. Creating the Archive
 * store here, outside any component, keeps its queries alive while moving
 * between Archive pages (otherwise leaving the landing page stops the year
 * query before it has fetched anything).
 */
export default defineNuxtRouteMiddleware(() => {
  useArchive()
  useArchiveFiveFest()
})
